import React, { Suspense, lazy } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import PageNotFound from "./PageNotFound";
import PrivateRoute from "./components/PrivateRoute";
import PublicRoute from "./components/PublicRoute";
import Quotation from "./Quotation/Quotation";
import QuotationView from "./Quotation/QuotationView";
import CreateQuotation from "./Quotation/CreateQuotation";
import EditQuotation from "./Quotation/EditQuotation";
import Ticket from "./Ticket/Ticket";
import CreateTicket from "./Ticket/CreateTicket";
import Subscribe from "./Subscribe";
import Dashboard from "./Dashboard";

const About = lazy(() => import("./About"));
const AIChatPage = lazy(() => import("./AIChat/AIChatPage"));
const AIQuotationPage = lazy(() => import("./AIChat/AIQuotationPage"));
const Login = lazy(() => import("./Login"));
const Register = lazy(() => import("./Register"));
const AdminLayout = lazy(() => import("./AdminLayout"));
function AppRoutes() {
const location = useLocation();
const path = location.pathname.toLowerCase();

const hideHeaderFooter =
  path === "/" ||
  path === "/ai-chat" ||
  path === "/ai-quotation" ||
  path === "/quotation" ||
  path.startsWith("/quotation/") || 
  path.startsWith("/quotation/create/") || 
  path.startsWith("/quotation/edit/:id") || 
  path === "/ticket" ||
  path.startsWith("/ticket/") || 
  path === "/subscribe";
  return (
    <>
      {!hideHeaderFooter && <Header />}
      <Suspense fallback={<div className="text-center mt-5">Loading...</div>}>
        <Routes>          
          <Route path="/about" element={<About />} />        
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route
            path="/register"
            element={
              <PublicRoute>
                <Register />
              </PublicRoute>
            }
          />

      <Route
        path="/"
        element={
          <PrivateRoute>
            <AdminLayout>
              <Dashboard />
            </AdminLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/ai-chat"
        element={
          <PrivateRoute>
            <AdminLayout>
              <AIChatPage />
            </AdminLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/ai-quotation"
        element={
          <PrivateRoute>
            <AdminLayout>
              <AIQuotationPage />
            </AdminLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/quotation"
        element={
          <PrivateRoute>
            <AdminLayout>
              <Quotation />
            </AdminLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/quotation/:id"
        element={
          <PrivateRoute>
            <AdminLayout>
              <QuotationView />
            </AdminLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/quotation/create"
        element={
          <PrivateRoute>
            <AdminLayout>
              <CreateQuotation />
            </AdminLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/quotation/edit/:id"
        element={
          <PrivateRoute>
            <AdminLayout>
              <EditQuotation />
            </AdminLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/ticket"
        element={
          <PrivateRoute>
            <AdminLayout>
              <Ticket />
            </AdminLayout>
          </PrivateRoute>
        }
      />

      <Route
        path="/ticket/create"
        element={
          <PrivateRoute>
            <AdminLayout>
              <CreateTicket />
            </AdminLayout>
          </PrivateRoute>
        }
      />
  
      <Route
        path="/subscribe"
        element={
          <PrivateRoute>
            <AdminLayout>
              <Subscribe />
            </AdminLayout>
          </PrivateRoute>
        }
      />


          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Suspense>
      {!hideHeaderFooter && <Footer />}
    </>
  );
}

export default AppRoutes;
